import { actionTypes } from '../actions/payment.action'

const initialState = {
    pay_type: null,
    pay_value: 0,
    success: null,
    error: {}
}

const paymentReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.CHANGE:
        return { ...state, ...payload }

    case actionTypes.SUCCESS:
        return { 
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return { 
            ...state, 
            error: payload 
        }

    case actionTypes.SESSION:
        console.log (payload)
        return { 
            ...state,
            session: payload
        }

    default:
        return state
    }
}

export default paymentReducer